/*地图函数工具库*/
import turf from "turf"/*turf库*/
import turf_buffer from '@turf/buffer'
import WKT from "terraformer-wkt-parser"/*wkt解析库*/
import turf_union from "@turf/union"/*wkt解析库*/
import turf_length from "@turf/length";
import turf_circle from "@turf/circle";

/*获取vue实例*/
let get_main_vue = () => {
  return window.vue
}

/**
 * 计算feature数据面积
 * @param feature数据
 * @return area 单位:平方米
 * */
let get_area_by_feature = (feature) => {
  let areaNum=0;
  if(feature instanceof  Array){
    let resNum=turf.featureCollection(feature);
    areaNum = turf.area(resNum)
  }else{
    areaNum = turf.area(feature);
  }
  return Number(areaNum.toFixed(2))
}


/**
 * 计算geometry数据面积
 * @param geometry数据
 * @return
 * */
let get_area_by_geometry = (geometry) => {
  let feature='';
  feature = get_feature_by_geometry(geometry);
  let areaNum = get_area_by_feature(feature);
  return Number(areaNum.toFixed(2));
}

/**
 * 计算wkt数据面积
 * @param wkt数据
 * @return
 * */
let get_area_by_wkt = (wkt) => {
  let feature='';
  feature=get_feature_by_wkt(wkt);
  let areaNum = get_area_by_feature(feature);
  return Number(areaNum.toFixed(2))
}

/**
 * 解析wkt，返回feature
 * @param wkt数据
 * @returns feature
 */
let get_feature_by_wkt = (wkt) => {
  let feature = ""
  if(wkt instanceof  Array){
    let temp_feature_arr = []
    wkt.forEach(item => {
      temp_feature_arr.push(turf.feature(WKT.parse(item)))
    })
    feature = turf.featureCollection(temp_feature_arr)
  }else{
    feature = turf.feature(WKT.parse(wkt))
  }

  return feature
}

/**
 * 解析geometry，返回feature
 * @param geometry数据
 * @returns feature
 * */
let get_feature_by_geometry = (geometry) => {
  let feature = ""
  if(geometry instanceof  Array){
    let temp_feature_arr = []
    geometry.forEach(item => {
      temp_feature_arr.push(turf.feature(item))
    })
    feature = turf.featureCollection(temp_feature_arr)
  }else{
    feature = turf.feature(geometry)
  }
  return feature
}

/*合并features*/
let union_feature = (all_features) => {
  if(!all_features || all_features.length == 0){return ""}
  if(all_features.length == 1){return all_features[0]}

  let res_feature = all_features[0]
  for(let i = 0 ;i < all_features.length - 1;  i++){
    res_feature = turf_union(res_feature,all_features[i + 1])
  }
  return res_feature
}

/**
 * 根据wkt获取中心点
 * @param wkt 支持数组
 * @returns {*}
 */
let get_center_by_wkt = (wkt) => {
  let feature = get_feature_by_wkt(wkt,true)
  let center = turf.center(feature);
  return center
}

/**
 * 根据feature获取中心点
 * @param feature 支持数组
 * @returns {*}
 */
let get_center_by_feature = (feature) => {
  let final_feature = feature
  if(feature instanceof Array){
    final_feature = turf.featureCollection(feature)
  }

  let center = turf.center(final_feature);
  return center
}

let  get_center_by_geojson = (geojson) =>  {
  let final_geojson = []
  if(geojson instanceof Array){
    geojson.forEach(item => {
      final_geojson.push(turf.feature(item))
    })

  }else{
    final_geojson = turf.feature(geojson)
  }

  return  get_center_by_feature(final_geojson)
}

/*根据wkt获取四至*/
let get_bbox_by_wkt = (wkt) => {
  let feature = get_feature_by_wkt(wkt,true)
  let bbox = turf.bbox(feature);
  return bbox
}

/*根据feature获取四至*/
let get_bbox_by_feature = (feature) => {
  if(feature instanceof  Array){
    feature = turf.featureCollection(feature)
  }
  let bbox = turf.bbox(feature);
  return bbox
}

/*根据geojson获取四至*/
let get_bbox_by_geojson = (geojson) => {
  if(geojson instanceof Array){
    let feature_arr = [];
    geojson.forEach(item => {
      feature_arr.push(turf.feature(item));
    })
   return get_bbox_by_feature(feature_arr)
  }else{
   return get_bbox_by_feature(turf.feature(geojson))
  }
}



//根据bbox算四至， bbox[ws_lng,wn_lat,en_lng,en_lat]
let get_sz_by_bbox = (bbox) => {
  let res = [
    bbox[0],
    bbox[3],

    bbox[2],
    bbox[3],

    bbox[2],
    bbox[1],

    bbox[0],
    bbox[1],

    bbox[0],
    bbox[3]
  ]

  return res
}

/*计算两点长度*/
let get_length_by_point = (point_1,point_2,options = {}) => {
  let radius = turf_length(turf.lineString([point_1, point_2]), {units: options.units || 'meters'});
  return radius
}

/*根据中心点半径计算院系feature*/
let get_circle_by_center = (center,radius,options_ori = {}) => {
  let options = {steps: 100, units: 'meters'};
  Object.assign(options,options_ori)
  let res = turf_circle(center, radius, options);
  return res
}

/**
 * 根据feature计算buffer
 * @param feature
 * @param buffer buffer长度
 * @param options_ori 配置项
 */
let get_buffer_by_feature = (feature,buffer,options_ori = {}) => {
  let options = {units: 'meters'};/*默认单位米*/
  Object.assign(options,options_ori)
  buffer = parseFloat(buffer)
  let res = turf_buffer(feature, buffer, options);
  return res
}

/*根据geometry计算buffer*/
let get_buffer_by_geometry = (geometry,options_ori = {}) => {
  let feature = turf.feature(geometry);
  let buffered_feature = get_buffer_by_feature(feature,options_ori)
  let res = buffered_feature.geometry
  return res
}

/*根据wkt计算buffer*/
let get_buffer_by_wkt = (wkt,options_ori = {}) => {
  let feature = get_feature_by_wkt(wkt)
  let buffered_feature = get_buffer_by_feature(feature,options_ori)
  let geometry = buffered_feature.geometry
  let res = WKT.convert(geometry)
  return res
}


export default {
  get_feature_by_geometry,
  get_area_by_feature,/*计算feature面积*/
  get_area_by_geometry,/*计算geometry面积*/
  get_area_by_wkt,/*计算wkt面积*/

  get_length_by_point,
  get_circle_by_center,

  union_feature,/*合并feature*/
  get_center_by_feature,/*获取feature中心点，支持数组*/
  get_center_by_geojson,/*获取geojson中心点，支持数组*/
  get_center_by_wkt,/*获取wkt中心点，支持数组*/
  get_bbox_by_wkt,/*根据wkt获取bbox [lng,lat,lng,lat]*/
  get_bbox_by_feature,/*根据feature获取bbox [lng,lat,lng,lat]*/
  get_bbox_by_geojson,/*根据geojson获取bbox [lng,lat,lng,lat]*/
  get_sz_by_bbox,/*根据bbox返回四至四个坐标点*/

  get_buffer_by_wkt,/*根据wkt计算buffer*/
  get_buffer_by_geometry,/*根据geometry计算buffer*/
  get_buffer_by_feature,/*根据feature计算buffer*/

}



// WEBPACK FOOTER //
// ./src/assets/js/global_tool/sys_tool/calculate_tool.js